import { Slido } from '@livekatsomo/models';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'next-i18next';

/**
 * Props for the SlidoAdminCard component
 */
export interface SlidoAdminCardProps {
  /** The Slido object to display */
  slido?: Slido | null;
  /** Function to call when the "Edit slido" button is clicked */
  onEditSlido?: () => void;
  /** Function to call when the "View slido" button is clicked */
  onViewSlido?: (slido: Slido) => void;
}

/**
 * A card component for displaying Slido information in the admin UI
 */
export function SlidoAdminCard({
  slido,
  onEditSlido,
  onViewSlido,
}: SlidoAdminCardProps) {
  const { t } = useTranslation();
  return (
    <Card aria-labelledby="slido-card-header">
      <CardHeader title={t('Slido')} id="slido-card-header" />
      <CardContent sx={{ maxHeight: '70vh', overflowY: 'auto' }}>
        {slido ? (
          <>
            <Typography>{t('Slido Id')}:</Typography>
            <Typography>{slido?.slidoId}</Typography>
          </>
        ) : (
          <Typography>{t('No slido configured')}</Typography>
        )}
      </CardContent>
      <CardActions>
        {onEditSlido ? (
          <Button size="small" onClick={onEditSlido}>
            {t('Edit slido')}
          </Button>
        ) : null}
        {onViewSlido && slido ? (
          <Button size="small" onClick={() => onViewSlido(slido)}>
            {t('View slido')}
          </Button>
        ) : null}
      </CardActions>
    </Card>
  );
}

export default SlidoAdminCard;
